module.exports = __webpack_public_path__ + "static/img/sm_25.685e656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_25.png
// module id = xQmM
// module chunks = 0